var map = {
	"./Budget/Budget.svg": [
		741,
		741
	],
	"./Budget/Buxheti Vjetor.svg": [
		6041,
		41
	],
	"./Budget/Monitorimi i Buxhetit.svg": [
		6801,
		801
	],
	"./Budget/Programi Buxhetor Afatmesëm (PBA).svg": [
		2737,
		737
	],
	"./Footer/Facebook.svg": [
		476,
		476
	],
	"./Footer/Instagram.svg": [
		3500,
		500
	],
	"./Footer/Mail.svg": [
		4909,
		909
	],
	"./Footer/Phone.svg": [
		1252,
		252
	],
	"./Footer/Pin.svg": [
		5765,
		765
	],
	"./Footer/Twitter.svg": [
		9021,
		21
	],
	"./LatestNews.svg": [
		3628,
		628
	],
	"./LatestNews/LatestNews.svg": [
		1759,
		759
	],
	"./Legislation/Arsimi, sportet dhe shërbimet argetuese.svg": [
		2991,
		991
	],
	"./Legislation/Generic.svg": [
		1793,
		793
	],
	"./Legislation/Legislation.svg": [
		545,
		545
	],
	"./Legislation/Menaxhimi Financiar Publik.svg": [
		6824,
		824
	],
	"./Legislation/Mjedisi dhe Burimet Natyrore.svg": [
		9570,
		570
	],
	"./Legislation/Organizimi dhe Shërbimet Publike.svg": [
		1247,
		247
	],
	"./Legislation/Shërbimet dhe përkujdesja shoqërore.svg": [
		4057,
		438
	],
	"./Legislation/Siguria Publike.svg": [
		934,
		934
	],
	"./Reports/Raportet e Kontrollit te Brendshëm Financiar Publik.svg": [
		6533,
		533
	],
	"./Reports/Raporti i vështirësive financiare.svg": [
		8575,
		575
	],
	"./Reports/Raporti i zbatimit të Buxhetit.svg": [
		8102,
		721
	],
	"./Reports/Reports.svg": [
		8337,
		337
	],
	"./Statistics/Detyrimet e Prapambetura.svg": [
		540,
		540
	],
	"./Statistics/DetyrimetPrapambetura.svg": [
		9573,
		573
	],
	"./Statistics/FunksionetDeleguara.svg": [
		9052,
		52
	],
	"./Statistics/Shpenzime.svg": [
		9523,
		523
	],
	"./Statistics/Shpenzimet.svg": [
		3077,
		77
	],
	"./Statistics/Statistics.svg": [
		249,
		249
	],
	"./Statistics/Te ardhura.svg": [
		5428,
		428
	],
	"./Statistics/TeArdhurat.svg": [
		630,
		630
	],
	"./Statistics/Transfertat e Buxhetit Qëndror.svg": [
		4195,
		195
	],
	"./Statistics/Viti.svg": [
		974,
		974
	],
	"./Statistics/Zgjidh Bashkine.svg": [
		5531,
		531
	],
	"./Statistics/bashkite.svg": [
		9855,
		855
	],
	"./Statistics/periudha-01.svg": [
		8807,
		188
	],
	"./Statistics/te-dhenat.svg": [
		3632,
		632
	],
	"./Statistics/viti-01.svg": [
		7486,
		486
	],
	"./default.svg": [
		9851,
		851
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9715;
module.exports = webpackAsyncContext;